
import React from 'react';
import { toast } from '@/hooks/use-toast';
import { Reward } from './types';

export const showRewardNotification = (reward: Reward) => {
  const getRarityEmoji = (rarity: string) => {
    switch (rarity) {
      case 'common': return '⚪';
      case 'uncommon': return '🟢';
      case 'rare': return '🔵';
      case 'legendary': return '🟡';
      default: return '⚪';
    }
  };

  const getRewardTypeEmoji = (type: string) => {
    switch (type) {
      case 'xp': return '⚡';
      case 'token': return '🎫';
      case 'card': return '🎴';
      case 'achievement': return '🏆';
      default: return '🎁';
    }
  };

  toast({
    title: `${getRarityEmoji(reward.rarity)} ${getRewardTypeEmoji(reward.type)} Reward Claimed!`,
    description: `${reward.name}: ${reward.description}`,
    duration: 5000,
  });
};
